import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "class-detail-container" }
const _hoisted_2 = {
  key: 0,
  class: "text-h6 my-5 ml-10"
}
const _hoisted_3 = { class: "operate-buttons d-flex justify-space-between ma-4" }
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = { class: "d-flex" }

import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import {classes} from "@/api";
import {useApi} from "@/api/handler";
import {ApiMap} from "@/api/type";
import StudentList from "@/components/class/StudentList.vue";
import FileUpload from "@/components/FileUpload.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import NewStudent from "@/components/class/NewStudent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClassDetail',
  setup(__props) {

const route = useRoute()
const routers = useRouter()
const id = Number(route.query.id)
const classDetail = ref<ApiMap['/class/:id']['resp'] | null>(null)
const showDialog = ref<boolean>(false)
const keyWord = ref<string>('')
const StudentListRef = ref<InstanceType<typeof StudentList> | null>(null)
const fileUploaded = ref<boolean>(false)
const showOverlay = ref<boolean>(false)

onMounted(() => {
  useClassDetail()
})

function handleSearch() {
  if (!StudentListRef.value) return
  StudentListRef.value.exposedStudentList(keyWord.value)
}

function handleUpload(file: File) {
  useUploadStudent(file)
}

function handleClose() {
  showOverlay.value = false
  StudentListRef.value.exposedStudentList(keyWord.value)
}

const useClassDetail = () => {
  useApi({
    api: classes.ClassDetail(id),
    onSuccess: resp => {
      classDetail.value = resp.data as ApiMap['/class/:id']['resp']
    }
  })
}

const useDeleteClass = () => {
  useApi({
    api: classes.DeleteClass(id),
    onSuccess: () => {
      routers.push('/')
    },
    tip: '删除成功'
  })
}

const useUploadStudent = (file: File) => {
  fileUploaded.value = true
  useApi({
    api: classes.UploadStudent(id, file),
    onSuccess: () => {
      if (!StudentListRef.value) return
      StudentListRef.value.exposedStudentList(keyWord.value)
    },
    Finally: () => {fileUploaded.value = false},
    tip: '上传成功'
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (classDetail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(classDetail.value.classCode), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_divider),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_text_field, {
            modelValue: keyWord.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyWord).value = $event)),
            variant: "outlined",
            density: "compact",
            rounded: "",
            width: "300px",
            "append-inner-icon": "mdi-magnify",
            placeholder: "搜索学生",
            "hide-details": "",
            clearable: "",
            "single-line": "",
            "onClick:appendInner": handleSearch,
            "onClick:clear": handleSearch
          }, null, 8, ["modelValue"]),
          _createVNode(_component_v_btn, {
            class: "mx-4",
            color: "blue-darken-1",
            rounded: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showOverlay.value = true))
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("手动添加学生")
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(FileUpload, { onUpload: handleUpload }),
          _createVNode(_component_v_btn, {
            variant: "text",
            color: "red-lighten-2",
            class: "ml-4",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showDialog.value = true))
          }, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("删除班级")
            ])),
            _: 1,
            __: [7]
          })
        ])
      ]),
      _createVNode(_component_v_card, {
        rounded: "",
        class: "ma-4"
      }, {
        default: _withCtx(() => [
          _createVNode(StudentList, {
            loading: fileUploaded.value,
            ref_key: "StudentListRef",
            ref: StudentListRef,
            cid: _unref(id),
            "key-word": keyWord.value
          }, null, 8, ["loading", "cid", "key-word"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDialog).value = $event)),
      width: "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(ConfirmDialog, {
          title: "删除班级",
          text: "此删除操作不可逆，是否确认删除？",
          onCancel: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false)),
          onConfirm: useDeleteClass
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(NewStudent, {
          cid: _unref(id),
          onClose: handleClose
        }, null, 8, ["cid"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})